// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-big-calendar/lib/css/react-big-calendar.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Ubuntu-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Ubuntu-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Ubuntu-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Ubuntu";
  src:
    local("Ubuntu-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Ubuntu";
  src:
    local("Ubuntu-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Ubuntu";
  src:
    local("Ubuntu-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}

* {
  margin: 0;
  font-family: "Ubuntu", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;

  /* Vars */

  --header-height: 120px;
  --header-height-less: calc(var(--header-height) - 50px);

  --admin-header-height: 75px;
  --admin-header-height-less: calc(var(--admin-header-height) - 5px);

  --overlay-color: rgba(0 0 0 / 60%);

  --header-z-index: 50;

  /* Colors */
  --primary-color: #32976b;
  --primary-color-hover: #227f56;
  --secondary-color: #ff6138;
  --secondary-color-hover: #e04b2d;
  --main-bg-color: #f6f7fb;
  --green-light: #beeb9f;
  --border-default-color: #ccd0d9;
  --border-light-color: #e5e7eb;
  --field-focus-color: #e0efe7;
  --gray-text-color: #818284;
}

#root {
  background-color: #f5f7fa;

  @media (min-width: 1440px) {
    --header-height: 120px;
  }

  @media (max-width: 991px) {
    --header-height: 90px;
    --header-height-less: calc(var(--header-height) - 20px);
  }

  @media (max-width: 767px) {
    --header-height: 60px;
  }
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.disabled {
  pointer-events: none;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB;;8DAE6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB;;8DAE4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB;;8DAE0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;;EAEtB,SAAS;;EAET,sBAAsB;EACtB,uDAAuD;;EAEvD,2BAA2B;EAC3B,kEAAkE;;EAElE,kCAAkC;;EAElC,oBAAoB;;EAEpB,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;;EAEzB;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,uDAAuD;EACzD;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;sEACoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["@import \"react-big-calendar/lib/css/react-big-calendar.css\";\n\n@font-face {\n  font-family: \"Ubuntu\";\n  src:\n    local(\"Ubuntu-Regular\"),\n    url(\"./assets/fonts/Ubuntu-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Ubuntu\";\n  src:\n    local(\"Ubuntu-Medium\"),\n    url(\"./assets/fonts/Ubuntu-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Ubuntu\";\n  src:\n    local(\"Ubuntu-Bold\"),\n    url(\"./assets/fonts/Ubuntu-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n* {\n  margin: 0;\n  font-family: \"Ubuntu\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n\n  /* Vars */\n\n  --header-height: 120px;\n  --header-height-less: calc(var(--header-height) - 50px);\n\n  --admin-header-height: 75px;\n  --admin-header-height-less: calc(var(--admin-header-height) - 5px);\n\n  --overlay-color: rgba(0 0 0 / 60%);\n\n  --header-z-index: 50;\n\n  /* Colors */\n  --primary-color: #32976b;\n  --primary-color-hover: #227f56;\n  --secondary-color: #ff6138;\n  --secondary-color-hover: #e04b2d;\n  --main-bg-color: #f6f7fb;\n  --green-light: #beeb9f;\n  --border-default-color: #ccd0d9;\n  --border-light-color: #e5e7eb;\n  --field-focus-color: #e0efe7;\n  --gray-text-color: #818284;\n}\n\n#root {\n  background-color: #f5f7fa;\n\n  @media (min-width: 1440px) {\n    --header-height: 120px;\n  }\n\n  @media (max-width: 991px) {\n    --header-height: 90px;\n    --header-height-less: calc(var(--header-height) - 20px);\n  }\n\n  @media (max-width: 767px) {\n    --header-height: 60px;\n  }\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.disabled {\n  pointer-events: none;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
